import { apiConfig } from "@/api/AppApi/config";
import ApiBuilder from "./api-builder";
import {
  IGetApplicationParams,
  IGetFromURLParams,
} from "./interfaces/interfaces";
import { useQuery } from "@tanstack/react-query";
import { Keys } from "../../common-interfaces/quiries-keys/keysValues";
import { getKey } from "../../common-interfaces/quiries-keys/queries-keys";
import { useLang } from "@/providers/langProvider";
import { getAccessToken } from "@/utils/functions/cookieOperations";

export const useBuilder = () => new ApiBuilder(apiConfig());
export const useGetFromURLQuery = (params: IGetFromURLParams) => {
  const lang = useLang();
  const getFrom = useBuilder();
  return useQuery(
    [...Object.values(params), lang],
    () => getFrom.getFromURL(params),
    {
      refetchOnWindowFocus: false,
      staleTime: Infinity,
      enabled: !!params.parentKey && params.parentKey != "-1",
    },
  );
};

export const useGetAddressQuery = (id?: number) => {
  const builder = useBuilder();
  return useQuery(
    [...getKey(Keys.get_address), id],
    () => builder.getAddress(id),
    {
      refetchOnWindowFocus: false,
      staleTime: Infinity,
    },
  );
};
export const useGetStudentBuilderQuery = (id?: number) => {
  const builder = useBuilder();
  return useQuery(
    [...getKey(Keys.get_student_builder), id],
    () => builder.getStudentBuilder(id),
    {
      refetchOnWindowFocus: false,
      staleTime: Infinity,
    },
  );
};
export const useGetAgentFormQuery = (id?: number) => {
  const builder = useBuilder();
  return useQuery(
    [...getKey(Keys.get_agent_form_builder), id],
    () => builder.getAgentFormBuilder(id),
    {
      refetchOnWindowFocus: false,
      staleTime: Infinity,
    },
  );
};
export const useGetApplicationQuery = (params: IGetApplicationParams) => {
  const builder = useBuilder();
  return useQuery(
    [...getKey(Keys.get_application), Object.values(params)],
    () => builder.getApplication(params),
    {
      refetchOnWindowFocus: false,
      staleTime: Infinity,
    },
  );
};
export const useGetRegisterFieldsQuery = (invoice_id?: number) => {
  const builder = useBuilder();
  return useQuery(
    [...getKey(Keys.get_registration), invoice_id],
    () => builder.getRegisterFields(invoice_id),
    {
      refetchOnWindowFocus: false,
      staleTime: Infinity,
    },
  );
};
export const useGetCartPageBuilderQuery = () => {
  return useQuery(
    [...getKey(Keys.get_cart_page_builder)],
    useBuilder().getCartPageBuilder,
    {
      refetchOnWindowFocus: false,
    },
  );
};
// export const useGetCheckoutPageBuilderQuery = () => {
//   return useQuery(
//     [...getKey(Keys.get_checkout_page_builder)],
//     useBuilder().getCheckoutPageBuilder,
//     {
//       refetchOnWindowFocus: false,
//     },
//   );
// };

export const useGetAddressPageBuilderQuery = () => {
  return useQuery(
    [...getKey(Keys.get_address_page_builder), getAccessToken()],
    useBuilder().getAddressPageBuilder,
    {
      refetchOnWindowFocus: false,
    },
  );
};
export const useGetProfilePageBuilderQuery = () => {
  return useQuery(
    [...getKey(Keys.get_profile_page_builder), getAccessToken()],
    useBuilder().getProfilePageBuilder,
    {
      refetchOnWindowFocus: false,
    },
  );
};
